// api-config.ts
export const API_CONFIG = {
  accounting: {
    baseUrl: '/nebula-accounting-core/api/v1',
    endpoints: {
      // ... endpoints existentes
      tipoCentroCostos: '/tipo-centro-costos',
      centroCostos: '/centros-costos',
      conceptosContables: '/conceptos-contables',
      parametrosSistema: '/parametros-sistema',
      tiposAsiento: '/tipos-asiento',
      tipoAsiento: '/conceptos-contables/tipos-asiento',
      estructuraCuentas: '/estructura-cuentas',
      conceptosDian: '/conceptos-dian',
      tipoPlanContable: '/tipo-plan-contable',
      tipoPlan: '/tipo-plan',
      tipoPlanHistorico: '/tipo-plan-historico',
      planCuentasHistorico: '/plan-cuentas-historico',
      estructuraHistorico: '/estructura-historico',
      dependencia: '/dependencia',
      monedas: '/monedas',
      tasasCambio: '/monedas/tasas',
      formatosContables: '/formatos-contables',
      terceros: '/terceros',
      planCuentas: '/plan-cuentas-contables',
      homologacionesPlanCuentas: '/homologaciones-cuentas',
      causaciones: '/causaciones',
      articulos: '/articulos',
      ordenesPago: '/ordenes-pago',
      logCausaciones: '/log-causaciones',
      saldosContables: '/saldos-contables',
      estadosDocumentoCausacion: '/estados-documento-causacion',
      estadosOrdenPago: '/estados-orden-pago',
      diferidos: '/diferidos',
      asientosDiferidos: '/asientos-diferidos',
      depreciaciones: '/depreciaciones',
      asientosContables: '/asientos-contables',
      entidadesBancarias: '/entidades-bancarias',
      causacionesAprobacion: '/causaciones-aprobacion',
      causacionesAnulacion: '/causaciones-anulacion',
      asientosAnulacion: '/asientos-anulacion',
      actividadEconomica: '/actividad-economica',
    },
  },
  masters: {
    baseUrl: '/nebula-masters/api/v1',
    endpoints: {
      parametrosSistema: '/',
      paises: '/paises',
      departamentos: '/departamentos',
      ciudades: '/ciudades',
      consecutivos: '/consecutivos',
      consecutivoTipos: '/consecutivos/tipos',
      roles: '/roles',
      triggers: '/trigger',
    },
  },
  treasury: {
    baseUrl: '/nebula-treasury/api/v1',
    endpoints: {
      parametrosSistema: '/parametros-tesoreria',
      embargos: '/embargos',
      cuentasBancarias: '/cuentas-bancarias',
      comprobanteEgreso: '/comprobantes-egreso',
      bancoPagos: '/banco-pagos',
      anulacionIngreso: '/anulacion-ingreso',
      terceroTesoreria: '/terceros-tesoreria',
    },
  },
  invoicing: {
    baseUrl: '/nebula-invoicing/api/v1',
    endpoints: {
      parametrosSistema: '',
      documentosFacturacion: '/documentos-facturacion',
      tiposDocumento: '/documentos-facturacion/tipos',
      conceptos: '/documentos-facturacion/conceptos',
      facturasSaldo: '/documentos-facturacion/tercero',
      facturasPage: '/documentos-facturacion/page-response',
    },
  },
} as const;
